// extracted by mini-css-extract-plugin
export default {"content":"AppErrorBoundary_content__Wo4In","text":"AppErrorBoundary_text__rqkxE","button":"AppErrorBoundary_button__FDP4t"};